/**
 * Role-code constants mirroring m16-labour-relations's own ROLES object
 * (packages/modules/m16-labour-relations/src/routes/shared.ts), so every
 * page checks the same literal strings the API gates on instead of
 * re-typing them.
 */
export const M16_ROLES = {
  LABOUR_OFFICER: 'LABOUR_OFFICER',
  MEDIATOR: 'MEDIATOR',
  LABOUR_INSPECTOR: 'LABOUR_INSPECTOR',
  CHIEF_INSPECTOR: 'CHIEF_INSPECTOR',
} as const;

export function hasAnyRole(roles: string[] | undefined, ...check: string[]): boolean {
  if (!roles) return false;
  return check.some((r) => roles.includes(r));
}
